<div class="full-modal-preview">
    <div class="full-modal-preview__preview-container">
        <ng-content select="full-modal-preview_container"></ng-content>
    </div>
    <div class="full-modal-preview__footer">
        <ng-content select="full-modal-preview_footer"></ng-content>
    </div>
</div>
